'use client';

import { useEffect, useState } from 'react';

/** Barra de progresso de leitura calculada pelo elemento [data-blog-article]. */
export function ReadingProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const el = document.querySelector<HTMLElement>('[data-blog-article]');
    function onScroll() {
      if (!el) return;
      const total = el.offsetHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(window.scrollY - el.offsetTop, 0), Math.max(total, 1));
      setPct(total > 0 ? (scrolled / total) * 100 : 0);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <div className="blog-progress" aria-hidden>
      <div className="bar" style={{ width: `${pct}%` }} />
    </div>
  );
}
